import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import DayJsUtils from '@date-io/dayjs'
import fr from 'dayjs/locale/fr'
import UIInput from '../../components/UI/UIInput'
import IconCalendar from '../Icon/IconCalendar'

function UIDatePicker({
  onDateChange,
  errorMessage,
  inputValue,
  disablePast,
  placeholder,
  icon,
  ...props
}) {
  const [isPickerOpen, setIsPickerOpen] = useState(false)

  const handleDateChange = (value) => {
    onDateChange(value)
    setIsPickerOpen(false)
  }

  const TextFieldComp = ({ placeholder, value, errorMessage }) => {
    return (
      <UIInput
        placeholder={placeholder}
        value={value}
        onClick={() => setIsPickerOpen(true)}
        errorMessage={errorMessage}
        icon={icon ? <IconCalendar /> : null}
      />
    )
  }

  const customTheme = createTheme({
    overrides: {
      MuiPickersCalendarHeader: {
        dayLabel: {
          color: 'black',
        },
      },
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: '#B9AA00',
        },
      },
      MuiPickersDay: {
        day: {
          color: 'light-gray',
          backgroundColor: 'white',
          borderRadius: '5px',
          '&:hover': {
            color: '#B9AA00',
          },
        },
        daySelected: {
          backgroundColor: '#B9AA00',
          color: 'white',
          borderRadius: '50%',
          '&:hover': {
            backgroundColor: '#B9AA00',
            color: 'white',
          },
        },
      },
    },
  })

  return (
    <ThemeProvider theme={customTheme}>
      <MuiPickersUtilsProvider utils={DayJsUtils} locale={fr}>
        <KeyboardDatePicker
          {...props}
          ampm={false}
          variant="inline"
          format="DD/MM/YYYY"
          placeholder={placeholder}
          disablePast={disablePast}
          value={inputValue}
          onClose={() => setIsPickerOpen(false)}
          open={isPickerOpen}
          onChange={handleDateChange}
          errorMessage={errorMessage}
          TextFieldComponent={(props) => {
            return <TextFieldComp {...props} />
          }}
        />
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  )
}

UIDatePicker.propTypes = {
  onDateChange: PropTypes.func,
  value: PropTypes.instanceOf(Date),
  errorMessage: PropTypes.string,
  inputValue: PropTypes.string,
  placeholder: PropTypes.string,
  disablePast: PropTypes.bool,
  icon: PropTypes.bool,
}
export default UIDatePicker
